import React, { useState } from "react";
import { Card, Offcanvas, Spinner } from "react-bootstrap";
import { FaDatabase, FaFilter } from "react-icons/fa6";

const ExportCSVData = ({
  Show,
  Hide,
  Title,
  getAllDataEntryCSVDownloadDatasets,
  csvLoader,
  studyPermission
}) => {
  const [type, setType] = useState("query");

  const exportOptions = [
    {
      value: "query",
      title: "CSV File",
      description: "Filter Query Data"
    },
    ...(
      (studyPermission?.dbpAllAccess ||
        studyPermission?.liveExtractDatasets ||
        studyPermission?.qcExtractDatasets)
        ? [
          {
            value: "fullWithDate",
            title: "CSV File",
            description: "Full Extract Data"
          }
        ]
        : [
          {
            value: "full",
            title: "CSV File",
            description: "Full Extract Data"
          }
        ]
    )
  ];

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="d-flex flex-wrap gap-3">
          {exportOptions.map((item) => (
            <Card
              key={item.value}
              onClick={() => setType(item.value)}
              className={`cursor-pointer flex-fill ${type === item.value
                  ? "border-primary shadow-sm"
                  : "border-light"
                }`}
              style={{
                minWidth: "220px",
                cursor: "pointer",
                backgroundColor:
                  type === item.value ? "#bcdbfc" : "#f0f0f0"
              }}
            >
              <Card.Body>
                <div className="d-flex align-items-center gap-3">
                  <div className="study_icopn">
                    {item.value === "query" ? <FaFilter /> : <FaDatabase />}
                  </div>

                  <div>
                    <Card.Title
                      className="mb-1"
                      style={{ fontSize: "16px" }}
                    >
                      {item.title}
                    </Card.Title>

                    <Card.Text style={{ fontSize: 13 }} className="mb-0">
                      {item.description}
                    </Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm text-end">
        <button
          disabled={csvLoader}
          onClick={() =>
            getAllDataEntryCSVDownloadDatasets(type, "csv")
          }
          className="updateProfile"
        >
          {csvLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              Exporting...
            </div>
          ) : (
            "Export"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ExportCSVData;